module.exports = __webpack_public_path__ + "static/media/50.a934e6b9.jpg";